import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "@radix-ui/themes/styles.css";
import { Theme } from "@radix-ui/themes";

import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from 'gsap/ScrollTrigger'

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBxFUE4wbHtg_-y0QNzXMLUGiHJpQCiFqc",
  authDomain: "bold-edge-media.firebaseapp.com",
  projectId: "bold-edge-media",
  storageBucket: "bold-edge-media.firebasestorage.app",
  messagingSenderId: "959578161729",
  appId: "1:959578161729:web:21b5751a2a5bc4243c3cc0",
  measurementId: "G-WBQXKXTZWM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const root = ReactDOM.createRoot(document.getElementById('root'));

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
